// Plain data (no React) so src/lib/structuredData.js can build the FAQPage
// schema from the same questions the accordion renders without pulling this
// lazily loaded page into the main bundle.
export const FAQS = [
  {
    question: "Can developers use voice typing to write code?",
    answer:
      "Developers can use voice typing mainly for the natural-language parts of programming: code comments, commit messages, pull request descriptions, documentation, tickets, and AI prompts. Dictating exact syntax is slower and less reliable than typing it, so most developers combine voice for prose with the keyboard for code.",
  },
  {
    question: "How do I dictate code comments?",
    answer:
      "Place your cursor where the comment belongs, start Zero Typing AI, and speak your comment as a complete sentence explaining why the code exists, not just what it does. Review the text, then continue. Add recurring technical terms to your Personal Dictionary to avoid repeated corrections.",
  },
  {
    question: "Can I dictate Git commit messages?",
    answer:
      "Yes. Speak a short summary line, then the reason for the change, then any notes for reviewers. Use the Transcript Only option when you want your exact words, or Fix Grammar when you want a light cleanup before committing.",
  },
  {
    question: "Is voice typing good for writing AI prompts?",
    answer:
      "Voice typing is one of the best uses for it. Detailed prompts produce better AI responses, and speaking a detailed prompt takes a fraction of the time typing does. Zero Typing AI also offers an Ask GPT option so you can speak a question and get an AI response directly.",
  },
  {
    question: "Does Zero Typing AI work with technical terms and jargon?",
    answer:
      "Zero Typing AI includes a Personal Dictionary where you can add custom words and spellings, such as library names, acronyms, and project names, so they are transcribed correctly in future dictation.",
  },
  {
    question: "Which devices does Zero Typing AI support?",
    answer:
      "Zero Typing AI is available for Mac, Windows, and Android, and it also offers a web app. This lets you use voice typing across your computers and phone.",
  },
  {
    question: "Is there a free voice typing option for developers?",
    answer:
      "Yes. ZT Basic is free and includes 15 minutes of audio transcription per week, a Personal Dictionary, and basic prompt selection. ZT Pro costs $8 per month with 20% off annual billing and adds unlimited words, unlimited audio transcription, and custom prompt creation.",
  },
  {
    question: "How is Zero Typing AI different from built-in dictation?",
    answer:
      "Built-in dictation typically transcribes speech without much cleanup. Zero Typing AI adds automatic punctuation, a Personal Dictionary, language detection, and AI rewriting options. For a full comparison, read our guide to voice typing vs built-in dictation.",
    // The accordion renders this answer with the comparison guide linked; the
    // schema above keeps the same sentence as plain text.
    linkTo: "/blog/voice-typing-vs-built-in-dictation",
    linkText: "voice typing vs built-in dictation",
  },
];
